import React, { Component } from 'react';
import { addPasskey, errorMessage, fetchPasskeyStatus, getStepUpExpiry, removePasskey } from '../../util/adminStepUp';

// Passkey management once verified: list, add another device, remove (the
// server refuses to remove the last one).
class AdminPasskeysList extends Component {
    state = { passkeys: this.props.passkeys || [], busy: false, error: null, open: false };

    refresh = () => fetchPasskeyStatus().then((s) => this.setState({ passkeys: s.passkeys }));

    add = async () => {
        this.setState({ busy: true, error: null });
        try {
            await addPasskey({ label: window.prompt('Name for this passkey', 'Passkey') || 'Passkey' });
            await this.refresh();
            this.setState({ busy: false });
        } catch (err) {
            this.setState({ busy: false, error: errorMessage(err, 'Could not add the passkey.') });
        }
    };

    remove = async (passkey) => {
        if (!window.confirm(`Remove the passkey "${passkey.label}"?`)) return;
        this.setState({ busy: true, error: null });
        try {
            await removePasskey(passkey.id);
            await this.refresh();
            this.setState({ busy: false });
        } catch (err) {
            this.setState({ busy: false, error: errorMessage(err, 'Could not remove the passkey.') });
        }
    };

    render() {
        const { passkeys, busy, error, open } = this.state;
        const expiry = getStepUpExpiry();
        return (
            <div className="admin-passkeys">
                {/* server-rendered admin tools; the passkey check also set their cookie */}
                <a className="button button--link" href="/blazer" target="_blank" rel="noopener noreferrer">Blazer</a>
                {' · '}
                <a className="button button--link" href="/sidekiq" target="_blank" rel="noopener noreferrer">Sidekiq</a>
                {' · '}
                <button className="button button--link" onClick={() => this.setState({ open: !open })}>
                    Admin passkeys ({passkeys.length}){expiry ? ` · verified until ${new Date(expiry).toLocaleString()}` : ''}
                </button>
                {open && (
                    <div className="section">
                        <ul>
                            {passkeys.map((p) => (
                                <li key={p.id}>
                                    <strong>{p.label}</strong> added {new Date(p.created_at).toLocaleDateString()}
                                    {p.last_used_at ? `, last used ${new Date(p.last_used_at).toLocaleDateString()}` : ''}
                                    {' '}
                                    <button className="button button--link" disabled={busy || passkeys.length <= 1} onClick={() => this.remove(p)}>Remove</button>
                                </li>
                            ))}
                        </ul>
                        <button className="button button--secondary button--small" disabled={busy} onClick={this.add}>Add another passkey</button>
                        {error && <p className="text--error m-t-1">{error}</p>}
                    </div>
                )}
            </div>
        );
    }
}

export default AdminPasskeysList;
